import React from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";

interface BlogPost {
  id: string;
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  featuredImage: string;
  categoryIds?: string[];
  tags: string[];
  author: {
    name: string;
    avatar: string;
  };
  publishDate: string;
  readTime: string;
  metaTitle: string;
  metaDescription: string;
  views: number;
  featured: boolean;
  status?: "draft" | "published" | "trashed";
}

interface QuickEditFormProps {
  post: BlogPost;
  onSave: (updates: Partial<BlogPost>) => void;
  onCancel: () => void;
}

const quickEditSchema = Yup.object({
  title: Yup.string().required("Title is required"),
  status: Yup.string().required("Status is required"),
});

const QuickEditForm: React.FC<QuickEditFormProps> = ({
  post,
  onSave,
  onCancel,
}) => {
  const handleSubmit = (values: any) => {
    onSave(values);
  };

  return (
    <Formik
      initialValues={{
        title: post.title,
        status: post.status || "draft",
      }}
      validationSchema={quickEditSchema}
      onSubmit={handleSubmit}
    >
      {({ errors, touched }) => (
        <Form className="quick-edit-form">
          <div className="form-row">
            <div className="form-group">
              <label>Title</label>
              <Field
                name="title"
                type="text"
                className={errors.title && touched.title ? "error" : ""}
              />
              {errors.title && touched.title && (
                <div className="error-message">{errors.title}</div>
              )}
            </div>

            <div className="form-group">
              <label>Status</label>
              <Field
                as="select"
                name="status"
                className={errors.status && touched.status ? "error" : ""}
              >
                <option value="draft">Draft</option>
                <option value="published">Published</option>
              </Field>
              {errors.status && touched.status && (
                <div className="error-message">{errors.status}</div>
              )}
            </div>
          </div>

          <div className="quick-edit-footer">
            <button type="button" className="btn-cancel" onClick={onCancel}>
              Cancel
            </button>
            <button type="submit" className="btn-update">
              Update
            </button>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default QuickEditForm;
